import styled, { ITheme } from '../../theme'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

const Text = styled.div<IWithSize>`
  justify-content: center;
  align-items: center;
  padding: ${({ size }) => (size ? 15 * size : 15)}px;
  background-color: ${(props: ITheme) => props.theme.colors.palette.paleGrey};
  font-size: ${({ size }) => (size ? 12 * size : 12)}px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.12px;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
`

const HeaderText = styled.div<IWithSize>`
  margin: 0px 0px ${({ size }) => (size ? 10 * size : 10)}px;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
`

export default Text
export { HeaderText }
